import React, {useEffect, useState, useRef } from "react";
import "./Header.css";
import {Contacts} from "./Contacts";
import {Menu} from "./Menu";
import {Language} from "./Language";
import { ReactComponent as BurgerIcon } from "../../icons/burger.svg";
import { ReactComponent as CloseIcon } from "../../icons/cancel.svg";
import { useLocation } from "react-router-dom";


export const Header = ({ appTheme = "classic" }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1279);
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();
    const isHomePage = location.pathname === "/";
    const isLionTheme = appTheme === "lion";
    const showClassicHomeNavigation = isHomePage && !isLionTheme;

    const menuRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1279);
            setMenuOpen(false);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        };

        if (menuOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuOpen]);

    return (
        <div className={isLionTheme ? "headerContainer headerContainerLion" : "headerContainer"}>
        <div className="header">
            <div className="logoLang">
                {!isLionTheme && (
                    <a href="/" className="page-scroll noPad">
                        <div className={'logoDiv'} />
                    </a>
                )}
                <Language />
            </div>
            {isMobile ? (
                <>
                    <div className="burgerIcon" onClick={() => setMenuOpen(!menuOpen)}>
                        {menuOpen ? <CloseIcon /> : <BurgerIcon />}
                    </div>
                </>
            ) : (
                <>
                    {showClassicHomeNavigation && <Menu />}
                    <Contacts
                        onLinkClick={() => setMenuOpen(false)}
                        showContactIcons={showClassicHomeNavigation}
                    />
                </>
            )}
        </div>
    {isMobile && menuOpen && (
        <div className={`mobileMenu open`} ref={menuRef}>
            {showClassicHomeNavigation && <Menu onLinkClick={() => setMenuOpen(false) }/>}
            <Contacts
                onLinkClick={() => setMenuOpen(false)}
                showContactIcons={showClassicHomeNavigation}
            />
        </div>
    )}
        </div>
    );
};
